import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(numeroFicha = '',numeroProforma = '' ,  notificadores , codTipoBono, codMonedaBono,
montoTotalBono,  obsBono, codFiveBono) {
    

  const data ={
    codColaborador:notificadores,
    codMonedaBono: codMonedaBono,
    codTipoBono: codTipoBono,
    montoTotalBono: montoTotalBono,
    numFichaVtaVeh: numeroFicha,
    numProfVeh: numeroProforma,
    obsBono: obsBono.length>0?obsBono.replace(/\n/g, "<br />"):'',
    codFiveBono
  }

  const config = {
        headers: {
          idUsuario: IDUSUARIO,
        }
    };

return  customAxios.post(`${FDV_URL}/ficha-venta/fichas-ventas/bonos-proforma-notificacion`,data, config)

}



// WEBPACK FOOTER //
// ./src/utils/addBonoProforma.js